import matchesType from './matchesType'

/**
 * Basic "history" tracker reducer for ease-of-use w/ any FSA(s).
 * Keeps track of a stack action payloads for targeted action types.
 * If you would like to track a stack of "RSAA Response Errors" (or
 * something along those lines) you can combine this with the `withError`
 * higher order reducer.
 * ```
 * (...string) => (state: [], action: FSA) => []
 * ```
 * @alias module:core
 * @param {*} defaultState initial state to return, null or error
 * @param {...string} types action types to match for payload history
 * @return {function} redux reducer function
 */
const payloadHistoryReducer = (defaultState = [], ...types) => {
  return (state = defaultState, action = {}) => {
    if (matchesType(action, ...types)) {
      return [ ...state, action.payload ]
    }
    return state
  }
}

export default payloadHistoryReducer
